"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlatButton = void 0;
/*
 * © 2024 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const styled_components_1 = require("../styled-components");
const Button_1 = require("./Button");
exports.FlatButton = (0, styled_components_1.styled)(Button_1.Button) `
  transition: background-color 0.4s;
  &:not(:hover) {
    background: #5550;
    box-shadow: 0 0 #0000;
  }
`;
//# sourceMappingURL=FlatButton.js.map